import PropTypes from 'prop-types';
import { attr, Model } from 'redux-orm';

class DashboardV2Appointment extends Model {
  static modelName = 'DashboardV2Appointment';

  static fields = {
    id: attr(),
    patientId: attr(),
    patient: attr(),
    workflowInstanceId: attr(),
    workflowDueAt: attr(),
    departmentAthenaId: attr(),
    providerAthenaId: attr(),
    date: attr(),
    time: attr(),
    visitType: attr(),
    clinician: attr(),
    location: attr(),
    noteUrl: attr(),
    readiness: attr(),
  };

  static schema = {
    _fields: PropTypes.exact({
      id: PropTypes.string,
      patientId: PropTypes.number,
      patient: PropTypes.object,
      workflowInstanceId: PropTypes.string,
      workflowDueAt: PropTypes.string,
      departmentAthenaId: PropTypes.string,
      providerAthenaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      date: PropTypes.string,
      time: PropTypes.string,
      visitType: PropTypes.string,
      clinician: PropTypes.string,
      location: PropTypes.string,
      noteUrl: PropTypes.string,
      readiness: PropTypes.object,
    }),
  };
}

export default DashboardV2Appointment;
